// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__3Et_w","label":"Category_label___CfwO","content":"Category_content__1fLGi","header":"Category_header__2Ixb3","location":"Category_location__3-HX6"};